<form class="input-field" [formGroup]="form" (ngSubmit)="onSubmit()" role="search" aria-label="Formulário de busca">
  <div class="form-control-container form-control-container--has-icon form-control-container--no-select">
    <label for="value" class="visually-hidden">{{ 'searchable.products' | translate }}</label>
    <input
      class="form-control"
      type="text"
      id="value"
      name="searchable"
      [placeholder]="placeholder$ | async"
      formControlName="value"
      (blur)="hideResults()"
      (focus)="onInputFocus()"
      (input)="onSearch($event)"
      autocomplete="off"
      [attr.aria-describedby]="showResults ? 'search-results' : null"
    />

    <span class="spinner" *ngIf="loading"></span>

    <button *ngIf="!loading" type="submit" class="form-control-icon" aria-label="Buscar">
      <span class="material-symbols-outlined">search</span>
    </button>
  </div>

  <!-- Resultados da busca -->
  <div class="search-results" *ngIf="showResults" id="search-results" role="region" aria-label="Resultados da busca">
    <!-- Resultados de Produtos -->
    <div class="results-container" *ngIf="productResults$ | async as products">
      <div class="results-header suggestions" *ngIf="products.suggestions.length > 0 || products.didYouMean">
        <span class="results-title">{{ 'searchable.termSuggestions' | translate }}</span>
        @if (products.suggestions.length > 0) {
          <ul class="results-list product-results" role="listbox" aria-label="Termos sugeridos">
            <li
              *ngFor="let suggestion of products.suggestions; trackBy: trackBySuggestion"
              (mousedown)="navigateToSuggestion(suggestion)"
              (keydown.enter)="navigateToSuggestion(suggestion)"
              (keydown.space)="navigateToSuggestion(suggestion)"
              role="option"
              tabindex="0"
              [attr.aria-selected]="false"
            >
              <div class="result-item">
                <span class="material-symbols-outlined result-icon">search</span>
                <span class="result-text">{{ suggestion }}</span>
              </div>
            </li>
          </ul>
        } @else {
          <ul class="results-list product-results" role="listbox" aria-label="Termos sugeridos">
            <li
              (mousedown)="navigateToSuggestion(products.didYouMean)"
              (keydown.enter)="navigateToSuggestion(products.didYouMean)"
              (keydown.space)="navigateToSuggestion(products.didYouMean)"
              role="option"
              tabindex="0"
              [attr.aria-selected]="false"
            >
              <div class="result-item">
                <span class="material-symbols-outlined result-icon">search</span>
                <span class="result-text">{{ products.didYouMean }}</span>
              </div>
            </li>
          </ul>
        }
      </div>

      <div class="results-header products" *ngIf="products.products.length > 0">
        <span class="results-title">{{ 'searchable.proSuggestions' | translate }}</span>
        <ul class="results-list product-results" role="listbox" aria-label="Produtos sugeridos">
          <li
            *ngFor="let product of products.products; trackBy: trackByProductCode"
            (mousedown)="selectProduct(product)"
            role="option"
            tabindex="0"
            (keydown.enter)="selectProduct(product)"
            (keydown.space)="selectProduct(product)"
            [attr.aria-selected]="false"
          >
            <div class="result-item">
              <cx-media class="result-product" [media]="imageProduct(product)" (mediaError)="onImageError($event)" />

              <span class="result-text">{{ product.name }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="no-results" *ngIf="showNoResults" role="status" aria-live="polite">
      <span class="material-symbols-outlined">search</span>
      <p>{{ 'searchable.emptyResults' | translate }}</p>
    </div>
  </div>
</form>
